import { X } from "lucide-react";

import { Button } from "@workspace/web-ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@workspace/web-ui/components/dialog";

import { formatMedicationDate } from "@workspace/lib/date";
import { RefillPrescriptionHistory } from "~/features/dashboard/pages/medicals/types";
import { getRefillMedicationStatusConfig } from "./medical-history";


export const MedicationHistoryModal = ({
  open,
  onClose,
  refillMedication,
}: {
  open: boolean;
  onClose: () => void;
  refillMedication: RefillPrescriptionHistory;
}) => {
  if (!refillMedication) {
    return null
  }

  const { color, text } = getRefillMedicationStatusConfig(refillMedication)

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <div
        className={` ${open ? "fixed inset-0 z-40 h-screen bg-black/5 backdrop-blur-sm" : ""} `}
      />
      <DialogContent className="max-w-sm rounded-lg sm:max-w-sm p-0 [&>button]:hidden">
        <DialogHeader className="flex flex-col p-5 border-b-2">
          <div>
            <Button
              onClick={onClose}
              className="absolute right-4 top-4 size-8 rounded-full bg-[#0404040D] text-gray-400 hover:bg-[#0404040D] hover:text-gray-600"
            >
              <X className="h-6 w-6 text-[#363840]" />
            </Button>
          </div>
          <div className="">
            <DialogTitle className="text-xl font-semibold">
              Medication details
            </DialogTitle>
          </div>
        </DialogHeader>

        <div className="w-full text-sm text-left space-y-4 px-5">
          <div className="flex items-center">
            <span className="#2D2F35 w-[155px]">Medication</span>
            <span className="text-[#202020CC]">
              {refillMedication.medication}
            </span>
          </div>

          <div className="flex items-center">
            <span className="#2D2F35 w-[155px]">Ordered date</span>
            <span className="text-[#202020CC]">
              {formatMedicationDate(refillMedication.ordered_date)}
            </span>
          </div>

          <div className="flex items-center">
            <span className="#2D2F35 w-[155px]">Delivered date</span>
            <span className="text-[#202020CC]">
              {formatMedicationDate(refillMedication.delivery_date)}
            </span>
          </div>

          <div className="flex items-center">
            <span className="#2D2F35 w-[155px]">Status</span>
            <span
              className={`px-3 py-1 text-xs font-medium rounded-full ${color}`}
            >
              {text}
            </span>
          </div>

          {refillMedication.reason && (
            <div className="flex items-center">
              <span className="#2D2F35 w-[155px]">Reason</span>
              <span className="text-[#202020CC]">
                {refillMedication.reason}
              </span>
            </div>
          )}
        </div>
        
        <div className="w-full mt-4 border-t-2 p-5">
          <Button
            className="w-full text-base font-normal h-11 bg-[#4272DD] rounded-lg"
            onClick={onClose}
          >
            Okay
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
